function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "22",
  height: "22",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4 1c0-.55-.45-1-1-1S2 .45 2 1v4H0v6h6V5H4V1zm4 14c0 1.3.84 2.4 2 2.82V22h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H8v2zm-8 0c0 1.3.84 2.4 2 2.82V22h2v-4.18C5.16 17.4 6 16.3 6 15v-2H0v2zM20 5V1c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V5h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H8v6h6V5h-2V1zm4 14c0 1.3.84 2.4 2 2.82V22h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z",
  fill: "#888",
  fillRule: "nonzero"
})));